(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6366],{

/***/ 42772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app",
      function () {
        return __webpack_require__(43671);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ LandingMobileApp; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-mobile-app/src/lib/components/qr-section/qr-section.module.css
var qr_section_module = __webpack_require__(5428);
var qr_section_module_default = /*#__PURE__*/__webpack_require__.n(qr_section_module);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/design-system/components/icons/src/index.ts + 266 modules
var icons_src = __webpack_require__(39957);
;// CONCATENATED MODULE: ../../../libs/landing/feature-mobile-app/src/lib/components/qr-section/qr-section.tsx






const QrCodeSection = ({ sectionData  })=>{
    const { vw  } = (0,src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isDesktop = vw > 767;
    const { title , qr_code , disclaimer , features_list  } = sectionData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (qr_section_module_default()).wrapper,
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (qr_section_module_default()).qrWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        element: "h2",
                        fontSize: "3xl",
                        className: (qr_section_module_default()).title,
                        children: title
                    }),
                    qr_code && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "aria-label": qr_code.alt ?? "",
                        className: (qr_section_module_default()).qrImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: qr_code.alt ?? "",
                            src: qr_code.filename,
                            height: 320,
                            width: 320,
                            layout: "responsive"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (qr_section_module_default()).disclaimer,
                        children: disclaimer
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (qr_section_module_default()).listWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (qr_section_module_default()).featureList,
                    "aria-label": "mobile app feature list",
                    children: features_list && features_list.filter((item)=>item && item.feature).map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            "aria-label": item.feature,
                            className: (qr_section_module_default()).featureItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (qr_section_module_default()).featureIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (qr_section_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.TickIcon, {
                                            size: 16
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    className: (qr_section_module_default()).featureText,
                                    children: item.feature
                                })
                            ]
                        }, item._uid))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../libs/landing/feature-mobile-app/src/lib/landing-mobile-app.module.css
var landing_mobile_app_module = __webpack_require__(96199);
var landing_mobile_app_module_default = /*#__PURE__*/__webpack_require__.n(landing_mobile_app_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-mobile-app/src/lib/components/why-app/why-app.module.css
var why_app_module = __webpack_require__(21145);
var why_app_module_default = /*#__PURE__*/__webpack_require__.n(why_app_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-mobile-app/src/lib/components/why-app/why-app.tsx



const ComponentMap = {
    cash: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.CashIcon, {
        size: 24
    }),
    filter: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.FilterIcon, {
        size: 24
    }),
    "home-delivery": /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.HomeDeliveryIcon, {
        size: 24
    }),
    "vehicle-front": /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_src.MakeModelIcon, {
        size: 24
    })
};
const WhyAppInformation = ({ heading , listOfItems , ariaLabelForList , disclaimer  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (why_app_module_default()).whyAppInformationContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (why_app_module_default()).whyAppInformationSectionHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "aria-label": ariaLabelForList,
                className: (why_app_module_default()).whyAppInformationSectionList,
                children: listOfItems.map((item)=>{
                    const iconName = item.icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        "aria-label": item.text,
                        className: (why_app_module_default()).whyAppInformationListItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (why_app_module_default()).whyAppInformationIconCard,
                                children: ComponentMap[iconName]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (why_app_module_default()).whyAppInformationIconCardText,
                                children: item.text
                            })
                        ]
                    }, item.text);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (why_app_module_default()).whyAppInformationDisclaimer,
                children: disclaimer
            })
        ]
    });

// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/landing/feature-mobile-app/src/lib/landing-mobile-app.tsx







const LandingMobileApp = ({ story , generatedAt , preview  })=>{
    const { body  } = story.content;
    const qrSectionData = body.find((qrdata)=>qrdata.component === "QR Section");
    const whyAppSectionData = body.find((whyAppData)=>whyAppData.component === "Why Section");
    const hasQrSection = qrSectionData;
    const hasWhyAppSection = whyAppSectionData;
    const { content  } = (0,storyblok_src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const [SEO] = (content === null || content === void 0 ? void 0 : content.SEO) ?? [
        {}
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "App - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isSlim: true,
                className: {
                    container: (landing_mobile_app_module_default()).qrWrapper
                },
                children: hasQrSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(QrCodeSection, {
                    sectionData: qrSectionData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isSlim: true,
                backgroundColor: "#F2F5FF",
                children: hasWhyAppSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyAppInformation, {
                    heading: whyAppSectionData.title,
                    listOfItems: whyAppSectionData.icon_list,
                    ariaLabelForList: "why app information section",
                    disclaimer: whyAppSectionData.disclaimer
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-mobile-app/src/lib/get-static-props.ts


async function getStaticPropsfn({ preview =false  }) {
    var ref, ref1;
    const story = await (0,storyblok_src/* getStoryBySlug */.OI)("app", {
        version: preview ? "draft" : "published"
    });
    (0,datadog_server_src/* setTag */.YA)("page.name", "app");
    (0,datadog_server_src/* setTag */.YA)("page.status-code", "200");
    (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
    (0,datadog_server_src/* setTag */.YA)("page.revalidate-in", "300s");
    (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
        preview
    }, null, 2));
    const HeroProps = story === null || story === void 0 ? void 0 : (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.hero) === null || ref1 === void 0 ? void 0 : ref1[0];
    return {
        props: {
            story,
            preview,
            generatedAt: Date.now(),
            layoutProps: {
                heroProps: HeroProps,
                showBorderRadius: false
            }
        },
        revalidate: 300
    };
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("mobile-app.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-mobile-app/src/index.ts



;// CONCATENATED MODULE: ./pages/app.tsx
var __N_SSG = true;



/***/ }),

/***/ 5428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qr-section_wrapper__Vq_Aq","title":"qr-section_title__Tcnsy","qrImage":"qr-section_qrImage___3iiA","listWrapper":"qr-section_listWrapper__OBzSP","featureItem":"qr-section_featureItem__7taQe","featureIcon":"qr-section_featureIcon__CvnBg","icon":"qr-section_icon__iRXEn","featureText":"qr-section_featureText__Xh7Ls"};

/***/ }),

/***/ 21145:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"whyAppInformationContainer":"why-app_whyAppInformationContainer__cjQj4","whyAppInformationSectionHeading":"why-app_whyAppInformationSectionHeading__wbQjA","whyAppInformationSectionList":"why-app_whyAppInformationSectionList__ySLaz","whyAppInformationListItem":"why-app_whyAppInformationListItem__7CXKJ","whyAppInformationIconCard":"why-app_whyAppInformationIconCard__v6Ui0","whyAppInformationIconCardText":"why-app_whyAppInformationIconCardText__ZdykA","whyAppInformationDisclaimer":"why-app_whyAppInformationDisclaimer__uCTUB"};

/***/ }),

/***/ 96199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"qrWrapper":"landing-mobile-app_qrWrapper__iBpuN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(42772); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);